module.exports = __webpack_public_path__ + "static/16-246040cb46ba0a1b4dba6852b0f8683f.wav";